// extracted by mini-css-extract-plugin
export default {"wrapper":"draw-status_wrapper","status":"draw-status_status"};